import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import $ from "jquery";

import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import Swal from "sweetalert2";
import InputAHSF from "../../../Components/InputAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import {
  AddActivitiesForStage,
  GetActivitiesForStageById,
  restValidateActivitiesForStage,
  UpdateActivitiesForStage,
  ValidateActivitiesForStage,
} from "../../../Redux/Reducers/ReportStage/ActivitiesForStage";

function ActivitesForStageForm(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ActivitiesForStage: state.ActivitiesForStage.ActivitiesForStage,
      loadingActivitiesForStage:
        state.loadingActivitiesForStage?.loadingActivitiesForStage,
      ActivitiesForStageValidate:
        state.ActivitiesForStage.ActivitiesForStageValidate,
    };
  });
  console.log(state.ItemTypeReducers, "rrrr");

  const ActivitiesForStageList = useSelector(
    (state) => state.ActivitiesForStage.ActivitiesForStage
  );
  console.log(ActivitiesForStageList, "sssss");

  const [AchievementDescription, setAchievementDescription] = useState(null);
  const [Challenges, setChallenges] = useState(null);
  const [AchievementRate, setAchievementRate] = useState(null);

  const [Attachment, setAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();

  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  // const AddInfo = async () => {
  //   const validationList = await dispatch(
  //     ValidateActivitiesForStage({
  //       achievementDescription: AchievementDescription,
  //       challenges: Challenges,

  //       achievementRate: AchievementRate == "" ? null : AchievementRate,

  //       attachment: Attachment?.name,
  //     })
  //   );
  //   if (validationList.payload.length === 0) {
  //     var formData = new FormData();
  //     formData.append("achievementDescription", AchievementDescription);
  //     formData.append("challenges", Challenges);
  //     formData.append("achievementRate", AchievementRate);
  //     formData.append("CanEdit", true);
  //     formData.append("file", Attachment);

  //     formData.append("Attachment", Attachment);
  //     formData.append("reportStageId", props.reportStageId);
  //     await dispatch(AddActivitiesForStage(formData));

  //     $(".close-btn").trigger("click");

  //     Swal.fire({
  //       position: "center",
  //       icon: "success",
  //       title: "تم اضافة المعلومات بنجاح",
  //       showConfirmButton: false,
  //       timer: 1500,
  //       // width: "500px",
  //     });

  //     dispatch(setRefreshTable());
  //   }
  // };

  useEffect(() => {
    dispatch(restValidateActivitiesForStage());
  }, []);

  const UpdateInfo = async () => {
    const validationList = await dispatch(
      ValidateActivitiesForStage({
        achievementDescription: AchievementDescription,
        challenges: Challenges,

        achievementRate: AchievementRate == "" ? null : AchievementRate,

        attachment: Attachment?.name ? Attachment?.name : Attachment,
      })
    );
    console.log(ActivitiesForStageList, "sssss");

    if (validationList.payload.length === 0) {
      var formData = new FormData();
      formData.append("ActivitiesForStageId", props.activitiesForStageId);
      formData.append(
        "ActivitiesObjectivesId",
        ActivitiesForStageList?.activitiesObjectivesId
      );
      formData.append("achievementDescription", AchievementDescription);
      formData.append("challenges", Challenges);
      formData.append("achievementRate", AchievementRate);
      formData.append("CanEdit", true);
      formData.append("file", Attachment);

      formData.append("Attachment", ActivitiesForStageList?.attachment);
      formData.append("reportStageId", props.reportStageId);
      dispatch(UpdateActivitiesForStage(formData));
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  console.log(dataJsonObject, "fff");

  useEffect(() => {
    if (props.canEdit == "edit") {
      dispatch(
        GetActivitiesForStageById({
          activitiesForStageId: props.activitiesForStageId,
        })
      );
    }
  }, [props.activitiesForStageId]);

  useEffect(() => {
    if (props.canEdit == "edit") {
      setAchievementRate(ActivitiesForStageList?.achievementRate);
      setChallenges(ActivitiesForStageList?.challenges);
      setAchievementDescription(ActivitiesForStageList?.achievementDescription);
      setAttachment(ActivitiesForStageList?.attachment);
    }
  }, [ActivitiesForStageList]);

  const HTML = (
    <>
      {" "}
      <div className="AddEdite">
        <InputAHSF
          fieldsName="ActivitesReport"
          show={true}
          disabled={true}
          // defaultValue={
          //   props.Action == "edit"
          //     ? ActivitiesForStageList?.rS_NT_Activities?.activitiesName
          //     : ""
          defaultValue={
            ActivitiesForStageList?.rS_NT_Activities?.activitiesName
          }
        />
        <TextAreaAHSF
          fieldsName="AchievementDescription"
          show={true}
          disabled={false}
          onChange={(e) => {
            setAchievementDescription(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit"
              ? ActivitiesForStageList?.achievementDescription
              : ""
          }
          showValidationMessage={
            state.ActivitiesForStageValidate
              ? state.ActivitiesForStageValidate.includes(
                  "AchievementDescription"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="AchievementRate"
          show={true}
          type={"rate"}
          // comma={true}
          disabled={false}
          onChange={(e) => {
            setAchievementRate(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit"
              ? ActivitiesForStageList?.achievementRate
              : ""
          }
          showValidationMessage={
            state.ActivitiesForStageValidate
              ? state.ActivitiesForStageValidate.includes("AchievementRate")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="Challenges"
          show={true}
          disabled={false}
          onChange={(e) => {
            setChallenges(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? ActivitiesForStageList?.challenges : ""
          }
          showValidationMessage={
            state.ActivitiesForStageValidate
              ? state.ActivitiesForStageValidate.includes("Challenges")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <div style={{ marginTop: "10px" }}>
          <label>
            مرفق
            <span className="star" style={{ color: "red" }}>
              *
            </span>
          </label>
          <div style={{ marginTop: "20px" }}>
            <AttachmentASFH
              id={"Attachment"}
              title={"إضافة مرفق"}
              show={true}
              clear={false}
              AttachementType="Attachment"
              singleFile={ActivitiesForStageList?.attachment}
              readOnly={false}
              onChange={(e) => {
                setFileChange(fileChange + 1);
                setAttachment(e.target.files[0]);
              }}
              showValidationMessage={
                state.ActivitiesForStageValidate
                  ? state.ActivitiesForStageValidate.includes("Attachment")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </div>

        <div className="containersButton">
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                UpdateInfo();
              }}
              disabled={false}
              title={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              text={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              show={true}
            />
          </div>
        </div>
      </div>
    </>
  );
  return (
    <>
      {props.canEdit == "edit" ? (
        <>
          {ActivitiesForStageList?.activitiesForStageId ? <>{HTML}</> : <></>}
        </>
      ) : (
        <>{HTML}</>
      )}
    </>
  );
}

export default ActivitesForStageForm;
